import { Component, OnInit } from '@angular/core';
import MetaMaskOnboarding from '@metamask/onboarding';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'narwhalia-meta-mask-popup',
  templateUrl: './meta-mask-popup.component.html',
  styleUrls: ['./meta-mask-popup.component.css']
})
export class MetaMaskPopupComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<MetaMaskPopupComponent>) { }

  ngOnInit(): void {
  }

	install() {
		new MetaMaskOnboarding().startOnboarding()
		this.dialogRef.close()
	}
}